import React from "react";
import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

// Founder's track record — styled brand wordmarks
const COMPANIES = [
  {
    name: "Domino's",
    render: (
      <span className="font-display text-2xl font-black tracking-tight text-[#0B6FB8]">
        Domino<span className="text-[#E31837]">’s</span>
      </span>
    ),
  },
  {
    name: "Saputo Dairy UK",
    render: (
      <span className="flex flex-col items-center leading-none">
        <span className="font-serif text-2xl font-bold italic text-[#E2001A]">Saputo</span>
        <span className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-[#E2001A]/80">
          Dairy UK
        </span>
      </span>
    ),
  },
  {
    name: "Salon Services",
    render: (
      <span className="font-display text-xl font-semibold lowercase tracking-tight text-[#EC008C]">
        salon services
      </span>
    ),
  },
  {
    name: "Westfield",
    render: (
      <span className="font-serif text-3xl font-bold italic text-[#E4002B]">Westfield</span>
    ),
  },
  {
    name: "Nxzen",
    render: (
      <span className="flex items-center gap-1.5">
        <span className="text-2xl font-bold text-[#0FA38A]">⋈</span>
        <span className="font-display text-2xl font-semibold lowercase tracking-tight text-foreground">
          nxzen
        </span>
      </span>
    ),
  },
  {
    name: "Dairy Crest",
    render: (
      <span className="flex flex-col items-center leading-none">
        <span className="mb-1 h-3 w-3 rounded-full bg-[#F5A800]" />
        <span className="font-display text-xl font-extrabold uppercase tracking-tight text-[#009639]">
          Dairy Crest
        </span>
      </span>
    ),
  },
  {
    name: "Dentsu Aegis Network",
    render: (
      <span className="flex flex-col items-center leading-tight text-foreground">
        <span className="font-display text-2xl font-bold lowercase tracking-tight">dentsu</span>
        <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-muted-foreground">
          Aegis
        </span>
        <span className="text-[11px] font-medium lowercase tracking-wide text-muted-foreground">
          network
        </span>
      </span>
    ),
  },
];

const Experience = () => {
  return (
    <section id="experience" className="relative py-20 sm:py-28" data-testid="experience-section">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-8 lg:px-12">
        <Reveal className="mb-14 text-center">
          <div className="flex justify-center">
            <Eyebrow>Experience</Eyebrow>
          </div>
          <h2 className="mt-5 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            Companies I've Worked With
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm text-muted-foreground sm:text-base">
            Two decades of delivery trusted by leading organisations across retail, food, healthcare
            and media — a selection of the brands I've partnered with.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {COMPANIES.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.05}>
              <motion.div
                whileHover={{ y: -5 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                className="group flex h-28 items-center justify-center rounded-2xl border border-border bg-card p-6 shadow-sm transition-shadow hover:shadow-lg"
                data-testid={`company-${c.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
                aria-label={c.name}
              >
                <span className="opacity-60 grayscale transition-all duration-500 group-hover:opacity-100 group-hover:grayscale-0">
                  {c.render}
                </span>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
